import { Link } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export type ErrorPageVariant = "portal" | "panel";

export interface ErrorPageContentProps {
  code: string;
  title: string;
  description: string;
  variant?: ErrorPageVariant;
  homeTo?: string;
  homeLabel?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorPageContent({
  code,
  title,
  description,
  variant = "portal",
  homeTo = "/",
  homeLabel = "Voltar para a home",
  onRetry,
  className,
}: ErrorPageContentProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center",
        variant === "portal" ? "min-h-[50vh]" : "min-h-[40vh] py-12",
        className,
      )}
      role="alert"
    >
      <p className="text-sm font-semibold uppercase tracking-wider text-brand-primary">{code}</p>
      <h1 className="mt-2 text-balance font-display text-3xl font-extrabold sm:text-4xl">{title}</h1>
      <p className="mt-3 max-w-md text-brand-on-surface-variant">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {onRetry ? (
          <Button type="button" variant="secondary" onClick={onRetry}>
            <RefreshCw className="h-4 w-4" />
            Tentar novamente
          </Button>
        ) : null}
        <Link to={homeTo}>
          <Button>{homeLabel}</Button>
        </Link>
      </div>
    </div>
  );
}
